import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-inputicon'
};
var InputIconStyle = BaseStyle.extend({
  name: 'inputicon',
  classes: classes
});

export { InputIconStyle as default };
//# sourceMappingURL=index.mjs.map
